import OfferingContainer from './OfferingContainer';
export default OfferingContainer;
